module.exports = __webpack_public_path__ + "img/stent2_both.cbef48ee.png";